import { useMemo } from 'react';

import useUpdateViewerPageState from '../../../../hooks/useUpdateViewerPageState';
import { EmbedItemType } from '../../../PdfViewer/index.types';

import * as Styled from './index.styles';
import EmbedVideo from './EmbedVideo';

export interface Props {
  embedItems?: EmbedItemType[];
  resizedImageSize: {
    heightRatio: number;
    widthRatio: number;
    xMargin: number;
    yMargin: number;
    width: number;
    height: number;
  };
  /** 지정 시 currentPage 대신 해당 페이지의 임베드를 렌더한다(V2 스크롤 모드용) */
  page?: number;
  /** 가림막/문의양식 게이트로 가려진 페이지 — 블러된 썸네일만 보여주고 재생하지 않는다 */
  isCovered?: boolean;
}

const EmbedLayer = ({
  embedItems,
  resizedImageSize,
  page,
  isCovered = false,
}: Props) => {
  const { currentPage } = useUpdateViewerPageState();

  /* embed는 조회시 전체페이지 값이 오기 때문에 현재 페이지의 임베드를 filter해주어야 한다 */
  const currentEmbedItems = useMemo(() => {
    return embedItems?.find((item) => item.page == (page ?? currentPage))
      ?.embed;
  }, [embedItems, currentPage, page]);

  if (!currentEmbedItems || currentEmbedItems.length < 1) {
    return null;
  }

  return (
    <Styled.Container
      style={{
        top: `${resizedImageSize.yMargin}px`,
        left: `${resizedImageSize.xMargin}px`,
        right: `${resizedImageSize.xMargin}px`,
        bottom: `${resizedImageSize.yMargin}px`,
      }}
    >
      {currentEmbedItems.map((item) => (
        <Styled.EmbedWrapper
          key={item.id}
          onClick={(e) => e.stopPropagation()}
          style={{
            left: `${item.rect_x * resizedImageSize.width}px`,
            top: `${item.rect_y * resizedImageSize.height}px`,
            width: `${item.rect_w * resizedImageSize.width}px`,
            height: `${item.rect_h * resizedImageSize.height}px`,
          }}
        >
          <EmbedVideo embed={item} isCovered={isCovered} />
        </Styled.EmbedWrapper>
      ))}
    </Styled.Container>
  );
};

export default EmbedLayer;
